import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const supportedLanguages = ['ru', 'en', 'tg', 'ky', 'uz', 'kk'];

function normalizeLanguage(lng: string): string {
  if (!lng || lng === 'not-detected') {
    return 'ru';
  }
  
  const normalized = lng.toLowerCase().split('-')[0];
  
  if (supportedLanguages.includes(normalized)) {
    return normalized;
  }
  
  if (normalized === 'kz') return 'kk';
  if (normalized === 'tj') return 'tg';
  
  return 'ru';
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ru',
    supportedLngs: supportedLanguages,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupQuerystring: 'lng',
      htmlTag: document.documentElement,
      convertDetectedLanguage: normalizeLanguage
    },
    initImmediate: false,
    saveMissing: false
  });

const storedLng = localStorage.getItem('i18nextLng');
if (storedLng) {
  const normalized = normalizeLanguage(storedLng);
  if (normalized !== storedLng) {
    localStorage.setItem('i18nextLng', normalized);
    i18n.changeLanguage(normalized);
  }
} else if (!i18n.isInitialized) {
  i18n.changeLanguage('ru');
}

export default i18n;